import { jsx as _jsx } from "react/jsx-runtime";
import { Card, CardContent, Stack } from '@mui/material';
import styles from 'components/pages/common/FormWrapper.module.scss';
export const FormWrapper = ({ children, maxWidth }) => (_jsx(Card, { className: styles.card, sx: { width: '100%', maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : 500 }, children: _jsx(CardContent, { children: _jsx(Stack, { spacing: 2.5, padding: 1, children: children }) }) }));
